// store/selectors/cartSelectors.js

// Ambil seluruh cart items
export const selectCartItems = (state) => state.cart.data;

// Hitung total quantity (jumlah pcs semua item)
export const selectCartCount = (state) =>
  state.cart.data.reduce((total, item) => total + (item.quantity || 1), 0);

export const selectCartTotalPrice = (state) =>
  state.cart.data.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
